import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteNotificationContactAction } from 'src/redux/actions/notificationActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import LoadingButton from 'src/components/UI/LoadingButton';

const DeleteNotificationContactDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteNotificationContact]) {
        return state.dialog[DIALOGS.deleteNotificationContact];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_notification_contact] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteNotificationContact }));
  };

  const handleOk = () => {
    dispatch(deleteNotificationContactAction(payload.notification, payload.contact));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-notification-contact"
      open={opened}>
      <DialogTitle id="deleting-notification-contact">
        {t(lang, 'menus.deleting_notification_contact')}
      </DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_notification_contact_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNotificationContactDialog;
